<template>
  <span>{{ displayValue }}</span>
</template>
<script lang="ts" setup>
  import { computed } from 'vue';
  import { formatUTC } from '@shared/services/format.service';

  export interface Props {
    value: string | Date;
    format?: string;
    isUtc?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), { format: 'MM/DD/YYYY' });
  const displayValue = computed(() => {
    return formatUTC(props.value, props.format);
  });
</script>
